// extracted by mini-css-extract-plugin
export default {"sliderBox":"RangeSlider_sliderBox__HBucF","question":"RangeSlider_question__xf8H3"};